import React from "react";
import { Church, Cake, Users, Briefcase, PartyPopper, BookOpen } from "lucide-react";
import { occasions } from "../mock";

const icons = { Church, Birthday: Cake, Family: Users, Business: Briefcase, Events: PartyPopper, Faith: BookOpen };

export default function OccasionsSection() {
  return (
    <section className="bg-[color:var(--dms-cream-2)] py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 text-center">
        <p className="kicker">Shop by occasion</p>
        <h2 className="font-serif text-4xl md:text-5xl text-[color:var(--dms-navy)] mt-4">What are the shirts for?</h2>
        <div className="w-14 h-[2px] bg-[color:var(--dms-peach)] mx-auto mt-5" />
        <p className="mt-6 text-[color:var(--dms-navy)]/70 max-w-xl mx-auto">Tell us the moment and we'll design around it — or browse our faith designs and make them yours.</p>
      </div>
      <div className="max-w-6xl mx-auto px-5 lg:px-8 mt-14 grid grid-cols-2 md:grid-cols-3 gap-4">
        {occasions.map((o) => {
          const Icon = icons[o.title] || icons.Church;
          return (
            <a href="#custom" key={o.title} className="group bg-white rounded-2xl p-7 border border-[color:var(--dms-navy)]/10 hover-lift text-left">
              <div className="w-11 h-11 rounded-full bg-[color:var(--dms-peach-light)]/60 flex items-center justify-center">
                <Icon className="w-5 h-5 text-[color:var(--dms-navy)]" />
              </div>
              <h3 className="font-serif text-2xl text-[color:var(--dms-navy)] mt-5">{o.title}</h3>
              <p className="mt-2 text-sm text-[color:var(--dms-navy)]/65">{o.desc}</p>
            </a>
          );
        })}
      </div>
    </section>
  );
}
